import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const announcementPreselection = {
  list: 'announcement_preselection',
  searchInfo: 'announcement_preselection/advanced_search_info',
  info: (rol_id) => `announcement_preselection/${rol_id}/info`,
  counters: (id) => `/announcement_preselection/${id}/counters/`,
};

const getPreselected = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = '',
  exportCSV = false,
) => {
  const params = makeFilterParams(
    query,
    page,
    pageSize,
    search,
    sortBy,
    exportCSV,
  );

  return await httpClient.get(
    exportCSV
      ? '/announcement_preselection/preselected/export'
      : '/announcement_preselection/preselected/',
    params,
  );
};

const announcementInfo = async (rol_id) =>
  await httpClient.get(`/announcement_preselection/${rol_id}/info/`);

const post = async (data) => {
  return await httpClient.post(`/announcement_preselection/`, data);
};

const getAll = async () => {
  return await httpClient.get(`/announcement_preselection/`);
};

const get = async (id) => {
  return await httpClient.get(`/announcement_preselection/${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`/announcement_preselection/${id}/`, data);
};

const patch = async (id, data) => {
  return await httpClient.patch(`/announcement_preselection/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/announcement_preselection/${id}`);
};

const filter = async (query) => {
  return await httpClient.get(`/announcement_preselection${query}`);
};

const ajaxTable = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = false,
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(
    query,
    page,
    pageSize,
    search,
    sortBy,
    exportCSV,
  );
  return await httpClient.get(
    exportCSV
      ? '/announcement_preselection/export/'
      : '/announcement_preselection/',
    params,
  );
};

const getValidationDocuments = async (id) => {
  return await httpClient.get(
    `/announcement_preselection_resume_documents/?filter[tercero]=${id}`,
  );
};

const sendFinalStatus = async (id, status) => {
  return await httpClient.patch(
    `/announcement_preselection/${id}/set_status/`,
    { estado: status },
  );
};

const massivePreselect = async (filters, data) => {
  return await httpClient.post(
    '/announcement_preselection_massive/preselect/',
    data,
    makeFilterParams(filters),
  );
};

const massiveReject = async (filters, data) => {
  return await httpClient.post(
    '/announcement_preselection_massive/reject/',
    data,
    makeFilterParams(filters),
  );
};

export {
  announcementPreselection,
  getPreselected,
  announcementInfo,
  post,
  getAll,
  get,
  put,
  remove,
  filter,
  patch,
  ajaxTable,
  getValidationDocuments,
  sendFinalStatus,
  massivePreselect,
  massiveReject,
};
